import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { useScrollManager } from '../../hooks/useScrollManager';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import './GettingHereSantaCatarina.css';

const GettingHereSantaCatarina: React.FC = () => {
  const { scrollState } = useScrollManager();
  const { setHoveredDestination } = useOverlayManager();

  useEffect(() => {
    window.scrollTo(0, 0);
    initializeAllFeatures();
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
  }, []);

  // Figma asset URLs
  const fullImage = '/assets/images/localhost/b511fc05b56f6f56ab808fe346dacf0108ddd079.png';
  const mapImage = '/assets/images/localhost/e81ab367ef65525aad1480d1faddeb5f7050ad91.png';
  const mapNavigation = '/assets/images/localhost/7480369bf8335012f137f5425989842c4b1fc8cf.png';
  const santaCatarinaLogoSmall = '/assets/images/localhost/cb0c7d03b8fd9ce19313644f58103ee696e9624c.svg';
  const santaCatarinaLogoSmall2 = '/assets/images/localhost/0501557fb03c945e93b7f590ca32f7a6f081cb88.svg';
  const markerArrow = '/assets/images/localhost/a33ba1312186de6cc92a2a3b035bfed60a30305c.svg';

  return (
    <div className="getting-here-santa-catarina">
      {/* Navigation - Santa Catarina variant (light) */}
      <UnifiedNavigation variant="light" destination="santa-catarina" />

      {/* Header Text Block */}
      <section className="getting-header-section" data-scroll-section>
        <div className="getting-header-content">
          <h1>Getting here</h1>
          <p>
            Situated on a private peninsula in Governador Celso Ramos, about 50 km north of Florianópolis, Awasi Santa Catarina is surrounded by the greenish waters of the Costa Esmeralda.
          </p>
        </div>
      </section>

      {/* Full Width Image */}
      <section className="getting-fullwidth-image" data-scroll-section>
        <div 
          className="fullwidth-image-container"
          style={{ backgroundImage: `url('${fullImage}')` }}
        />
      </section>

      {/* Map Section */}
      <section className="getting-map-section" data-scroll-section>
        <div className="map-section-container">
          {/* Map Image */}
          <div className="map-container">
            <div 
              className="map-image"
              style={{ backgroundImage: `url('${mapImage}')` }}
            >
              {/* Map Navigation Controls */}
              <div 
                className="map-navigation"
                style={{ backgroundImage: `url('${mapNavigation}')` }}
              />
              
              {/* Santa Catarina Location Marker */}
              <div className="map-marker santa-catarina-marker">
                <div className="marker-tag">
                  <img src={santaCatarinaLogoSmall} alt="Santa Catarina" className="marker-logo" />
                  <img src={santaCatarinaLogoSmall2} alt="" className="marker-logo-overlay" />
                </div>
                <img src={markerArrow} alt="" className="marker-arrow" />
              </div>
            </div>
          </div>

          {/* Text Block */}
          <div className="map-text-block">
            <h2>Getting to Awasi Santa Catarina</h2>
            
            <div className="map-text-content">
              <div className="info-section">
                <h3>Getting to Awasi Santa Catarina</h3>
                <p>The nearest airport is Florianópolis International Airport – Hercílio Luz (FLN), with daily flights from the main Brazilian capitals and international connections via São Paulo and Rio de Janeiro.</p>
                <p>São Paulo (CGH): 1h 10m</p>
                <p>São Paulo (GRU): 1h 25m</p>
                <p>Rio de Janeiro (GIG): 1h 30m</p>
                <p>Foz do Iguaçu (IGU): 1h 20m</p>
                <p>Buenos Aires (EZE): 2h 20m</p>
                <p>Buenos Aires (AEP): 2h 20m</p>
                <p>Santiago de Chile (SCL): 3h 46m</p>
                <p>Panama City (PTY): 6h 50m</p>
                <p>Lisbon (LIS): 10h 15m</p>
              </div>

              <button className="contact-button">
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Transfer Information Block */}
      <section className="getting-transfer-section" data-scroll-section>
        <div className="transfer-content">
          <h2>
            The journey to the lodge takes around 1h15 by road. It is also possible to organize private transfers or arrival by helicopter upon request.
          </h2>
          <button className="contact-button dark">
            CONTACT US
          </button>
        </div>
      </section>

      {/* Instagram Gallery */}
      <div className="instagram-section-wrapper">
        <InstagramSection />
      </div>

      {/* Footer - Santa Catarina variant */}
      <Footer variant="santa-catarina" />
    </div>
  );
};

export default GettingHereSantaCatarina;